import { List, Map } from 'immutable';
import { Component, OnInit, Input, OnChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'sub-industries',
  templateUrl: './sub-industries.component.html',
  styleUrls: ['./sub-industries.component.css']
})
export class SubIndustriesComponent implements OnInit, OnChanges {


  @Input() public data: List<Map<string, any>>;
  @Output() fieldChange: EventEmitter<any> = new EventEmitter();
  @Output() rowDelete: EventEmitter<any> = new EventEmitter();
  @Output() rowAdd: EventEmitter<any> = new EventEmitter();

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
  }

  public handleFieldChange(e: Event, row: number): void {
    this.fieldChange.emit({ e, row });
    this.cd.detach();
  }

  public handleRowDelete(row: number): void {
    this.rowDelete.emit(row);
    this.cd.reattach();
  }

  public handleRowAdd(): void {
    this.rowAdd.emit();
    this.cd.reattach();
  }


}
